import { FirstToFileFeatureFlags } from '@model/widget.model';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeatureFlagState } from '@store/reducers/feature-flags.reducer';

export const selectFeatureFlags = createFeatureSelector<FeatureFlagState>('featureFlags');

export const selectFeatureFlag = (key: keyof FirstToFileFeatureFlags) => createSelector(selectFeatureFlags, (state) => state.flags[key]);
